import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analytics-presentation',
  templateUrl: './analytics-presentation.component.html',
  styleUrls: ['./analytics-presentation.component.scss']
})
export class AnalyticsPresentationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
